export { StatCardContent } from "../../../../../shared/frontend/dashboard/StatCardContent";
export type { StatCardContentProps } from "../../../../../shared/frontend/dashboard/StatCardContent";
